export const EnvironmentVariables = {
  countryCode: 'COUNTRY_CODE',
  deleteEndpoint: 'DELETE_ENDPOINT',
  deleteReasonEndpoint: 'DELETE_REASON_ENDPOINT',
  eligibleToDeleteEndpoint: 'ELIGIBLE_TO_DELETE',
  host: 'HOST',
  identityHost: 'IDENTITY_HOST',
  ssoHost: 'SSO_HOST',
  clientId: 'CLIENT_ID',
  clientSecret: 'CLIENT_SECRET',
  reactApp: 'REACT_APP',
  reactEnvPrefix: 'REACT_ENV_PREFIX',

}
